import { ProductCostLabelTextHelper } from '../labelTextHelper/ProductCostLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['dateCreateAt', 'dateModifyAt'];

export const ProductCostHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: ProductCostLabelTextHelper.getLabelText.sku, value: 'sku' },
            { text: ProductCostLabelTextHelper.getLabelText.productCostAmount, value: 'productCostAmount' },
            {
                text: ProductCostLabelTextHelper.getLabelText.dateEffectiveOn,
                value: 'dateEffectiveOn',
                format: 'date'
            },
            { text: ProductCostLabelTextHelper.getLabelText.dateCreateAt, value: 'dateCreateAt', format: 'datetime' },
            { text: ProductCostLabelTextHelper.getLabelText.dateModifyAt, value: 'dateModifyAt', format: 'datetime' }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: ProductCostLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportWithCostFields() {
        const fields = this.getFilteredHeaderItems().filter((item) => item.value === 'productCostAmount');
        return fields.reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportWithCostHeaders() {
        return this.getHeaderItems().filter((item) => item.value === 'productCostAmount');
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
